import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import {Translate, translate} from 'views/module';

const CaregiverEditStatus = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldStatus = oldData.status;
  const newStatus = newData.status;

  return (
    <Stack>
      <Translate
        expression='caregiver.CaregiverDetail.Correspondance.Logs.EditStatus.Text'
        substitute={{
          oldStatus: translate(`caregiver.Status.${oldStatus}.Title`),
          newStatus: translate(`caregiver.Status.${newStatus}.Title`),
        }}
      />
    </Stack>
  );
};
CaregiverEditStatus.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(CaregiverEditStatus);
